import { ChangeDetectorRef, Component, forwardRef, ViewEncapsulation, ChangeDetectionStrategy, AfterViewChecked } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { VrSlideToggle } from './models/vr-slide-toggle';

const VRC_SLIDE_TOGGLE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => VrcSlideToggleComponent),
  multi: true
};

@Component({
  selector: 'vrc-slide-toggle',
  templateUrl: './vrc-slide-toggle.component.html',
  styleUrls: ['./vrc-slide-toggle.component.scss'],
  providers: [VRC_SLIDE_TOGGLE_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VrcSlideToggleComponent extends VrSlideToggle implements AfterViewChecked {
  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }
}
